// Mapping of style categories to their PDF page numbers
// Based on the official MTM Stylebook index
// This allows displaying the correct reference image for each category

export const STYLE_PAGE_MAPPING = {
  jacket: {
    totalPages: 109,
    categories: {
      // Construction (Pages 1-3)
      "Canvas Construction": { pages: [2], description: "Chest canvas type - Full, half, fused options" },
      "Sleeve Pad Type": { pages: [3], description: "Sleeve pad construction options" },
      
      // Lapel & Collar (Pages 4-12)
      "Lapel Style": { pages: [4, 5, 6, 7], description: "Lapel or collar styles - Notch, peak, shawl, etc." },
      "Lapel Buttonhole Position": { pages: [8], description: "Buttonhole placement on lapel" },
      "Lapel Buttonhole Style": { pages: [9], description: "Buttonhole types - straight, round, real, sham" },
      "Lapel Flower Style": { pages: [10], description: "Flower buttonhole options" },
      "Collar Tab Style": { pages: [11], description: "Collar tab designs" },
      "Collar Material": { pages: [12], description: "Collar fabric options" },
      "Lapel Width": { pages: [17], description: "Lapel width measurements" },
      "Lapel Material": { pages: [55], description: "Lapel fabric options" },
      
      // Front Buttons (Pages 13-19)
      "Front Buttons": { pages: [13, 14, 15, 16], description: "Button quantity - Single & double breast options" },
      "Front Button Style": { pages: [18], description: "Button fastening style" },
      "Buttoning Design": { pages: [19], description: "Button arrangement design" },
      
      // Chest Area (Pages 20-26)
      "Chest Dart": { pages: [20], description: "Chest dart style options" },
      "Chest Pocket": { pages: [21, 22, 23], description: "Chest pocket styles - welt, patch, besom" },
      "Chest Pocket Fixation": { pages: [24], description: "How chest pocket is attached" },
      "Chest Pocket Material": { pages: [25], description: "Chest pocket fabric options" },
      "Chest Pocket Welt Direction": { pages: [26], description: "Welt fabric yarn stripe direction" },
      
      // Lower Pockets (Pages 27-40)
      "Lower Pocket Style": { pages: [27, 28, 29, 30, 31, 32], description: "Lower pocket options - flap, patch, besom" },
      "Ticket Pocket": { pages: [33, 34, 35, 36], description: "Ticket pocket styles" },
      "Outside Pocket Buttonhole Thread": { pages: [37], description: "Pocket buttonhole thread color" },
      "Pocket Besom Direction": { pages: [38], description: "Besom yarn stripe direction" },
      "Pocket Flap Inner Side": { pages: [39], description: "Flap inner side material" },
      "Exchange Pocket Style": { pages: [40], description: "Exchange pocket options" },
      
      // Vent (Pages 41-44)
      "Vent Style": { pages: [41, 42, 43], description: "Back vent options - center, side, no vent" },
      "Vent Length Adjustment": { pages: [44], description: "Vent length modifications" },
      
      // Lining & Facing (Pages 45-54)
      "Lining Style": { pages: [45, 46, 47, 48, 49, 50, 51], description: "Lining options - full, half, quarter" },
      "Facing Style": { pages: [52, 53, 54], description: "Facing construction options" },
      
      // Pic Stitch / Top Stitch (Pages 56-70)
      "Inner Pic Stitch": { pages: [56], description: "Inner pic stitch options" },
      "Pic Stitch / Top Stitch": { pages: [57, 58, 59, 60], description: "Outside pic stitch and top stitch" },
      "Shoulder Seam Pic Stitch": { pages: [61, 62], description: "Shoulder seam stitching" },
      "Armhole Front Pic Stitch": { pages: [63], description: "Front armhole stitching" },
      "Armhole Back Pic Stitch": { pages: [64], description: "Back armhole stitching" },
      "Collar Front Pic Stitch": { pages: [65], description: "Collar and front edge stitching" },
      "Back Center Pic Stitch": { pages: [66], description: "Back center seam stitching" },
      "Sleeve Seam Pic Stitch": { pages: [67], description: "Sleeve seam stitching" },
      "Chest Pocket Pic Stitch": { pages: [68], description: "Chest pocket stitching" },
      "Pocket Flap Pic Stitch": { pages: [69], description: "Pocket flap stitching" },
      "Vent Pic Stitch": { pages: [70], description: "Vent stitching options" },
      
      // Shoulder (Pages 71-75)
      "Shoulder Style": { pages: [71], description: "Shoulder construction - natural, padded, soft" },
      "Shoulder Epaulet Style": { pages: [72], description: "Epaulet options" },
      "Canvas Presentation Sample": { pages: [73], description: "Canvas sample reference" },
      "Elbow Patch": { pages: [74], description: "Elbow patch designs" },
      "Shoulder Patch": { pages: [75], description: "Shoulder patch options" },
      
      // Sleeve (Pages 76-82)
      "Sleeve Slit Style": { pages: [76, 77, 78], description: "Sleeve slit/vent options" },
      "Sleeve Cuff Style": { pages: [79], description: "Cuff construction" },
      "Sleeve Buttonhole Style": { pages: [80], description: "Sleeve buttonhole types" },
      "Sleeve Buttons": { pages: [81, 82], description: "Sleeve button quantity and style" },
      
      // Button & Special Styles (Pages 83-87)
      "Button Style": { pages: [83], description: "Button types - horn, corozo, metal, etc." },
      "Tuxedo Options": { pages: [84], description: "Tuxedo styling options" },
      "Lining Design": { pages: [85], description: "Lining pattern/design options" },
      "Sweat Pad Style": { pages: [86], description: "Sweat pad options" },
      "Sweat Pad Requirement": { pages: [87], description: "Sweat pad specifications" },
      
      // Inner Pockets (Pages 88-102)
      "Inner Pocket Style": { pages: [88, 89, 90, 91], description: "Inner pocket options" },
      "Left Inner Pocket": { pages: [92, 93], description: "Left inner pocket styles" },
      "Right Inner Pocket": { pages: [94], description: "Right inner pocket styles" },
      "Inner Pocket Besom Design": { pages: [95], description: "Inner pocket besom options" },
      "Upper Forward Pocket": { pages: [96], description: "Upper forward pocket design" },
      "Left Pen/Cell Phone Pocket": { pages: [97], description: "Left pen and cell phone pocket" },
      "Right Pen/Cell Phone Pocket": { pages: [98], description: "Right pen and cell phone pocket" },
      "Name Card Pocket": { pages: [99], description: "Name card pocket design" },
      "Right Lower Name Card Pocket": { pages: [100], description: "Right lower name card pocket" },
      "MP3 Pocket": { pages: [101], description: "MP3/device pocket design" },
      "Inner Pocket Seal Design": { pages: [102], description: "Inner pocket seal options" },
      
      // Labels & Finishing (Pages 103-109)
      "Brand Label Position": { pages: [103], description: "Brand label placement" },
      "Customer Name Monogram": { pages: [104], description: "Monogram position options" },
      "Collar Loop Style": { pages: [105], description: "Collar loop style and position" },
      "Sleeve Label Position": { pages: [106], description: "Sleeve label placement" },
      "Customer Indicated Sticker": { pages: [107], description: "Customer sticker options" },
      "Fabric Information Tag": { pages: [108], description: "Fabric info tag placement" },
      "Stomach Size Adjustment": { pages: [109], description: "Stomach adjustment options" },
      
      // Posture Adjustment Codes
      "Chest Pocket Posture": { pages: [], description: "Chest pocket position adjustments" },
      "Lower Pocket Flap Width": { pages: [], description: "Lower pocket flap width options" },
      "Ticket Pocket Posture": { pages: [], description: "Ticket pocket position and size" },
      "Back Vent Length Adjustment": { pages: [], description: "Back vent length modifications" },
      "Armhole Adjustment": { pages: [], description: "Armhole height adjustments" },
      "Shoulder Posture Adjustment": { pages: [], description: "Shoulder slope and posture corrections" }
    }
  },
  pants: {
    totalPages: 49,
    categories: {
      "Waistband Height": { pages: [3], description: "Waistband height options" },
      "Waistband Style": { pages: [3, 4], description: "Waistband construction" },
      "Pleats Style": { pages: [5, 6], description: "Pleat options - plain, single, double" },
      "Pleat Depth": { pages: [6], description: "Pleat depth measurements" },
      "Front Pleat Net Length": { pages: [7], description: "Pleat length options" },
      "Front Pocket Style": { pages: [8, 9, 10, 11], description: "Front pocket options - slant, straight, jean" },
      "Front Pocket Opening": { pages: [11, 12], description: "Pocket opening styles" },
      "Front Pocketing": { pages: [12], description: "Pocketing depth options" },
      "Waistband Pocket": { pages: [13], description: "Waistband pocket styles" },
      "Watch Pocket Style": { pages: [14, 15], description: "Watch pocket options" },
      "Back Pocket Style": { pages: [16, 17, 18, 19], description: "Back pocket options - besom, flap, patch" },
      "Back Pocket Position": { pages: [19], description: "Back pocket placement" },
      "Bottom Style": { pages: [20, 21], description: "Hem and cuff options" },
      "Belt Loop Style": { pages: [22, 23, 24], description: "Belt loop options" },
      "Belt Loop Quantity": { pages: [24], description: "Number of belt loops" },
      "Belt Loop Position": { pages: [25], description: "Belt loop placement" },
      "Waist Adjustment": { pages: [26, 27], description: "Waist adjustment options - buckle, buttons" },
      "Back Center Seam": { pages: [28], description: "Back seam options" },
      "Fly Style": { pages: [29, 30], description: "Fly construction options" },
      "Heel Guard": { pages: [31], description: "Heel guard options" },
      "Ironware Logo Tag": { pages: [32], description: "Logo tag placement" },
      "Beltloop Bartack Style": { pages: [33], description: "Bartack styles" }
    }
  },
  vest: {
    totalPages: 20,
    categories: {
      "Collar Style": { pages: [2, 3], description: "V shape, U shape, lapel styles" },
      "Lapel Adjustment": { pages: [3], description: "Lapel length adjustments" },
      "Lapel Buttonhole Position": { pages: [4], description: "Buttonhole placement" },
      "Buttonhole Style": { pages: [4], description: "Buttonhole types" },
      "Collar & Lapel Fabric": { pages: [5], description: "Fabric options" },
      "Front Buttons": { pages: [6, 7], description: "Button quantity options" },
      "Front Pocket Style": { pages: [8, 9], description: "Front pocket options" },
      "Chest Pocket": { pages: [9], description: "Chest pocket styles" },
      "Back Style": { pages: [10, 11], description: "Back construction options" },
      "Back Buckle Style": { pages: [11], description: "Buckle options" },
      "Bottom Style": { pages: [12], description: "Bottom edge styles" },
      "Edge & Pic Stitch": { pages: [13], description: "Edge finishing" },
      "Lining Style": { pages: [14], description: "Lining options" },
      "Inner Pocket": { pages: [15], description: "Inner pocket styles" },
      "Button Style": { pages: [16], description: "Button types" },
      "Labels & Monogram": { pages: [17, 18, 19], description: "Label placement" }
    }
  },
  overcoat: {
    totalPages: 52,
    categories: {
      "Canvas Construction": { pages: [3], description: "Canvas construction options" },
      "Lapel Style": { pages: [4, 5, 6], description: "Lapel styles for overcoats" },
      "Collar & Lapel Corner": { pages: [6], description: "Corner styles" },
      "Lapel Dart": { pages: [7], description: "Dart options" },
      "Lapel Buttonhole Position": { pages: [7, 8], description: "Buttonhole placement" },
      "Lapel Buttonhole Style": { pages: [8], description: "Buttonhole types" },
      "Lapel Buttonhole Length": { pages: [9], description: "Buttonhole lengths" },
      "Collar Fabric": { pages: [9, 10], description: "Collar fabric options" },
      "Collar Felt Style": { pages: [10], description: "Collar felt options" },
      "Front Buttons - Single Breast": { pages: [11, 12], description: "Single breasted options" },
      "Front Buttons - Double Breast": { pages: [12, 13], description: "Double breasted options" },
      "Lapel Width": { pages: [14], description: "Lapel width options" },
      "Front Buttonhole Style": { pages: [15], description: "Front buttonhole styles" },
      "Chest Pocket": { pages: [16, 17], description: "Chest pocket options" },
      "Lower Pocket Style": { pages: [18, 19, 20, 21], description: "Lower pocket options" },
      "Ticket Pocket": { pages: [22], description: "Ticket pocket styles" },
      "Vent Style": { pages: [23, 24], description: "Back vent options" },
      "Vent Adjustments": { pages: [24], description: "Vent length adjustments" },
      "Length": { pages: [25], description: "Coat length options" },
      "Back Length Adjustment": { pages: [26], description: "Length adjustments" },
      "Lining Style": { pages: [27, 28], description: "Lining options" },
      "Shoulder Style": { pages: [29], description: "Shoulder construction" },
      "Sleeve Style": { pages: [30], description: "Sleeve options" },
      "Sleeve Cuff Adjustment": { pages: [31], description: "Cuff adjustments" },
      "Inner Pocket - Left Breast": { pages: [32, 33, 34], description: "Left inner pocket" },
      "Inner Pocket - Right Breast": { pages: [35, 36], description: "Right inner pocket" },
      "Pen Pocket": { pages: [37], description: "Pen pocket options" },
      "Name Card Pocket": { pages: [38, 39], description: "Card pocket options" },
      "MP3 Pocket": { pages: [40], description: "MP3 pocket style" },
      "Inner Pocket Bartack": { pages: [40], description: "Bartack styles" },
      "Label Position - Fabric": { pages: [41, 42], description: "Fabric label placement" },
      "Label Position - Brand": { pages: [42, 43], description: "Brand label placement" },
      "Label Position - Name": { pages: [43, 44], description: "Name label placement" },
      "Collar Tab Style": { pages: [45, 46], description: "Collar tab options" },
      "Care Label Location": { pages: [47], description: "Care label placement" },
      "Shipments & Accessories": { pages: [48], description: "Accessory options" },
      "Handmade Pic Stitch": { pages: [49], description: "Handmade stitch options" }
    }
  }
};

export default STYLE_PAGE_MAPPING;
